export default __webpack_public_path__ + "static/media/72.ebc9c588.jpeg";